// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KyNo","col":"styles_col__1B4PX"};